module.exports = __webpack_public_path__ + "static/media/capitalHart.fb5d0767.png";